import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.currentComponent), {
    userCompanyId: _ctx.userCompanyId,
    carrierCompanyId: _ctx.carrierCompanyId,
    docType: _ctx.docType,
    carrierInfo: _ctx.carrierInfo,
    onShowSignForm: _ctx.switchToSignForm,
    onShowMainOnboarding: _ctx.switchToMainOnboarding
  }, null, 40, ["userCompanyId", "carrierCompanyId", "docType", "carrierInfo", "onShowSignForm", "onShowMainOnboarding"]))
}